import { mapActions, mapGetters } from 'vuex'
import Tooltip from '@/components/custom/Tooltip.vue'
import { getDefaultBinLocationId } from '@/helpers'
import { filterTaxesForSale, getMasterDataText } from '../../helpers'
import { isMenuOnlineOrder, transformOrderRef } from '../../lib/v-calendar/utils/helpers'
import _ from 'lodash'
import { uuid } from 'vue-uuid'

export default {
  components: {
    Tooltip,
  },

  props: {
    backTo: {
      type: String,
      default: 'choose-product',
    },
  },

  data () {
    return {
      radioSkuId: null,
      checkBoxModifierOptionIds: [],
      switchTaxIds: [],
      switchDiscountIds: [],
      quantity: 1,
      note: '',
      isInvalid: false,
      isInvalidModifierIds: [],
      isInvalidModifierCount: 0,
    }
  },

  computed: {
    ...mapGetters({
      pos: 'getPos',
      product: 'getPosSelectedProduct',
      sku_id: 'getPosSelectedSkuId',
      originDiscounts: 'getDiscounts',
      orignTaxes: 'getTaxes',
      currency: 'getCurrency',
      queue_number: 'getPosSelectedQueueNumber',
      table_number: 'getPosSelectedTableNumber', // selected table_number,
      order: 'getPosEditOrder', // get data edit
      getMainStock: 'getMainStock', // get stock_id from primary warehouse
      section: 'getPosSection',
      posSettings: 'getPosSetting',
      posSession: 'getPosSession',
      selectedLots: 'getPosSelectedLots',
      selectedSerials: 'getPosSelectedSerials',
      isAssignedSkuToStock: 'isAssignedSkuToStock',
      getPosOrdersById: 'getPosOrdersById', // get orders from table number
      getPosQueueById: 'getPosQueueById',
    }),
    isEdit () {
      if (this.order) {
        return true
      }
      return false
    },
    isValid () {
      return this.radioSkuId != null
    },
    isValidModifiers() {
      // validate modifiers
      let isValidModifiers = true
      this.isInvalidModifierIds = []
      for (const modifier of this.mapProductModifiers) {
        const addInvalidModifierId = () => {
          if (!this.isInvalidModifierIds.includes(modifier.modifier_id)) {
            this.isInvalidModifierIds.push(modifier.modifier_id)
          }
          isValidModifiers = false
        }
        if (modifier.is_required) {
          let selectedCount = 0
          const optionIds = modifier.options.map((opt) => opt.modifieroption_id)
          for (const optionId of optionIds) {
            if (this.checkBoxModifierOptionIds.includes(optionId)) {
              selectedCount++
            }
          }
          if (modifier.min_required_count == modifier.max_required_count && modifier.max_required_count != 0) {
            if (selectedCount != modifier.min_required_count) {
              addInvalidModifierId()
            }
          } else if (modifier.min_required_count != 0 && modifier.max_required_count == 0) {
            if (selectedCount < modifier.min_required_count) {
              addInvalidModifierId()
            }
          } else if (modifier.min_required_count == 0 && modifier.max_required_count != 0) {

          } else if (modifier.min_required_count != 0 && modifier.max_required_count != 0) {
            if (selectedCount < modifier.min_required_count) {
              addInvalidModifierId()
            }
          }
        }
      }
      if (!isValidModifiers) {
        this.isInvalidModifierCount++
      }
      return isValidModifiers
    },
    useBarcodeScanner () {
      return this.sku_id && this.section.prev == 'choose-product'
    },
    discounts () {
      const { product, originDiscounts } = this
      return originDiscounts.map((dis) => {
        let amountText = ''
        let tooltipTexts = ''

        if (dis.type === 'general') {
          if (dis.value_type === 'percentage') {
            amountText = `(${dis.value_amount}%)`
          } else {
            amountText = `(${this.currency} ${dis.value_amount})`
          }
        } else if (dis.type === 'conditional') {
          const getCondi = this.getDiscountCondition(dis.conditions, this.quantity)
          if (getCondi) {
            if (getCondi.value_type === 'percentage') {
              amountText = `(${getCondi.value_amount}%)`
            } else {
              amountText = `(${this.currency} ${getCondi.value_amount})`
            }
          }

          tooltipTexts = dis.conditions.reduce((conditionTextArray, next) => {
            const condi = next
            // >= 10 ลด 10%
            const strCondition = [condi.condition].map((value) => {
              if (value === '>=') {
                return this.$t('message.conditiongreaterequal')
              } else if (value === '=') {
                return this.$t('message.conditionequal')
              }
              return this.$t('message.conditionlessthanequal')
            })[0]
            const quantity = condi.quantity
            const discountTranslate = this.$t('message.discount').toLowerCase()
            const strValueAmount = [condi.value_type].map((value) => {
              if (value === 'percentage') {
                return `${condi.value_amount}%`
              }
              return `${this.currency} ${condi.value_amount}`
            })
            conditionTextArray.push(`${strCondition} ${quantity} ${discountTranslate} ${strValueAmount}`)
            return conditionTextArray
          }, [])
        }

        return {
          ...dis,
          amountText,
          tooltipTexts,
        }
      })
    },
    taxes () {
      const { product, orignTaxes } = this
      const taxes = orignTaxes.filter((tax) => {
        const isExist = product.taxes.map((pTax) => (pTax.tax_id)).includes(tax.tax_id)
        return isExist
      })
      return filterTaxesForSale(taxes).map((tax) => {
        return {
          ...tax,
          tax_name: getMasterDataText(tax.tax_name, this.$t),
        }
      })
    },
    isSelectedLot () {
      return this.lot.selected.length
    },
    isSelectedSerial () {
      return this.serial.selected.length
    },
    mapProductModifiers() {
      return this.product.modifiers.map((modifier) => {
        let selectedCount = 0
        const optionIds = modifier.options.map((opt) => opt.modifieroption_id)
        for (const optionId of optionIds) {
          if (this.checkBoxModifierOptionIds.includes(optionId)) {
            selectedCount++
          }
        }
        return {
          ...modifier,
          options: modifier.options.map((opt) => {
            const isOptionSelected = this.checkBoxModifierOptionIds.includes(opt.modifieroption_id)
            return {
              ...opt,
              isSelected: isOptionSelected,
              disabled: (() => {
                const maxRequiredCount = this.getModifierMaxSelected(modifier)
                const checkDisabled = () => {
                  if (maxRequiredCount != 0) {
                    if (selectedCount >= maxRequiredCount && !isOptionSelected) {
                      return true
                    }
                  }
                }
                if (modifier.min_required_count == modifier.max_required_count && modifier.max_required_count != 0) {
                  if (checkDisabled()) {
                    return true
                  }
                } else if (modifier.min_required_count != 0 && modifier.max_required_count == 0) {

                } else if (modifier.min_required_count == 0 && modifier.max_required_count != 0) {
                  if (checkDisabled()) {
                    return true
                  }
                } else if (modifier.min_required_count != 0 && modifier.max_required_count != 0) {
                  if (checkDisabled()) {
                    return true
                  }
                }
                return false
              })(),
            }
          }),
          isInvalid: [...this.isInvalidModifierIds].includes(modifier.modifier_id),
        }
      })
    },
  },
  methods: {
    ...mapActions([
      'addPosOrder',
      'updatePosOrder',
      'setPosSection',
      'setPosSectionWith',
      'setPosSelectedProduct',
      'setPosLocalStorage',
      'createOrder',
      'updateOrder',
    ]),
    getSku (sku_id) {
      for (let i in this.product.prices) {
        let item = this.product.prices[i]
        if (item.sku_id == sku_id) {
          return item
        }
      }
      return null
    },
    getModifiers (modifieroption_ids) {
      let product = this.product
      let modifiers = product.modifiers
      var tempModiIds = []
      var results = []
      for (let i in modifieroption_ids) {
        let modifieroption_id = modifieroption_ids[i]
        for (let j in modifiers) {
          let modifier = modifiers[j]
          for (let k in modifier.options) {
            let option = modifier.options[k]
            if (option.modifieroption_id == modifieroption_id) {
              if (tempModiIds.indexOf(modifier.modifier_id) === -1) {
                results.push({
                  modifier_id: modifier.modifier_id,
                  modifier_name: modifier.modifier_name,
                  options: [],
                })
                tempModiIds.push(modifier.modifier_id)
              }
              for (let l in results) {
                if (results[l].modifier_id == modifier.modifier_id) {
                  results[l].options.push({
                    modifieroption_id: option.modifieroption_id,
                    option: option.option,
                    price: option.price,
                  })
                }
              }
            }
          }
        }
      }
      return results
    },
    getDiscounts (switchDiscountStatus) {
      let discounts = this.discounts
      var results = []
      for (let i in switchDiscountStatus) {
        if (switchDiscountStatus[i] == true) {
          for (let j in discounts) {
            if (j == i) {
              let discount = discounts[j]
              let dataSet = {
                discount_id: discount.discount_id,
                discount_name: discount.discount_name,
                type: discount.type,
              }
              if (discount.type === 'general') {
                dataSet['value_type'] = discount.value_type
                dataSet['value_amount'] = discount.value_amount
              } else if (discount.type === 'conditional') {
                const getCondi = this.getDiscountCondition(discount.conditions, this.quantity)
                dataSet['value_type'] = getCondi.value_type
                dataSet['value_amount'] = getCondi.value_amount
              }
              results.push(dataSet)
            }
          }
        }
      }
      return results
    },
    getTaxes (switchTaxStatus) {
      let taxes = this.taxes
      var results = []
      for (let i in switchTaxStatus) {
        if (switchTaxStatus[i] == true) {
          for (let j in taxes) {
            if (j == i) {
              let tax = taxes[j]
              results.push({
                ...tax,
                tax_id: tax.tax_id,
                tax_name: tax.tax_name,
                type: tax.type,
                amount: tax.amount,
              })
            }
          }
        }
      }
      return results
    },
    getCheckBoxModifierOptionIds (modifiers) {
      var arr = []
      for (let i in modifiers) {
        let modifier = modifiers[i]
        for (let j in modifier.options) {
          let item = modifier.options[j]
          arr.push(item.modifieroption_id)
        }
      }
      return arr
    },
    getSwitchDiscountIds (orderDiscounts, { updateGeneral = false, updateCondition = false }) {
      var arr = []
      for (const discount of this.discounts) {
        let found = false
        for (const orderDiscount of orderDiscounts) {
          if (discount.discount_id == orderDiscount.discount_id) {
            if (found) {
              continue
            }
            if (discount.type === 'general') {
              if (updateGeneral) {
                arr.push(true)
              } else {
                arr.push(!!this.switchDiscountIds[arr.length])
              }
              found = true
            } else if (discount.type === 'conditional') {
              const getCondi = this.getDiscountCondition(discount.conditions, this.quantity)
              if (getCondi) {
                arr.push(true)
                found = true
              }
            }
          }
        }
        if (!found) {
          arr.push(false)
        }
      }
      return arr
    },
    getSwitchTaxIds (taxes) {
      var arr = []
      for (let i in this.taxes) {
        var found = false
        let item = this.taxes[i]
        for (let j in taxes) {
          if (item.tax_id == taxes[j].tax_id) {
            if (!found) {
              arr.push(true)
              found = true
            }
          }
        }
        if (!found) {
          arr.push(false)
        }
      }
      return arr
    },
    onSelectedSkuId (sku_id) {
      this.radioSkuId = sku_id
    },
    onSelectedModifierOptionId (option_id) {
      let data = this.checkBoxModifierOptionIds
      if (data.indexOf(option_id) === -1) {
        data.push(option_id)
      } else {
        for (let i in data) {
          if (data[i] == option_id) {
            data.splice(i, 1)
          }
        }
      }
    },
    onClickBack() {
      this.setPosSection(this.backTo)
    },
    onClickDone () {
      // do validate
      this.isValid
      this.isValidModifiers

      if (!this.isValid || !this.isValidModifiers) {
        if (!this.isValid) {
          this.isInvalid = true
        }
        return
      }

      this.note = this.note === undefined || this.note === null ? '' : this.note

      const isActive_menuOnline = this.posSettings.menu_online.is_active
      const queue = this.getPosQueueById(this.queue_number)
      const isMenuOnlineQueue = queue && queue.qrcode_id != null
      const order_id = this.isEdit ? _.cloneDeep(this.order.order_id) : uuid.v4()

      const branchAssignWhId = this.$store.state.posBranch.branch.whId
      var that = this
      let product = this.product
      let queue_number = this.queue_number
      let table_number = this.table_number
      let sku_id = this.radioSkuId
      let sku = this.getSku(sku_id)
      let stocks = sku.stocks
      let item = this.getProductFullName(product.product_name, sku.attributes)
      let quantity = parseFloat(this.quantity)
      let modifiers = this.getModifiers(this.checkBoxModifierOptionIds)
      let discounts = this.getDiscounts(this.switchDiscountIds)
      let taxes = this.getTaxes(this.switchTaxIds)
      let note = this.note.trim().length > 0 ? this.note : null
      let stock_id = this.isAssignedSkuToStock(branchAssignWhId, sku_id) ? stocks[0].stock_id : null
      let warehouse_id = this.isAssignedSkuToStock(branchAssignWhId, sku_id) ? stocks[0].warehouse_id : null
      const bin_location_id = this.isAssignedSkuToStock(branchAssignWhId, sku_id) && branchAssignWhId ? getDefaultBinLocationId(stocks[0].stock_locations) : null
      let unit = product.unit
      const useLot = this.isProductUseLot(sku)
      const useSerial = this.isProductUseSerial(sku)

      if (!this.isEdit) {
        const newOrder = {
          queue_number: queue_number,
          table_number: table_number,
          sku_id: sku_id,
          item: item,
          price: sku.price,
          cost: sku.cost,
          quantity: quantity,
          attributes: sku.attributes,
          modifiers: modifiers,
          discounts: discounts,
          taxes: taxes,
          note: note,
          stock_id: stock_id,
          warehouse_id: warehouse_id,
          bin_location_id: bin_location_id,
          unit: unit,
          delay: 1,
          order_id: isActive_menuOnline && isMenuOnlineQueue ? order_id : null,
        }
        if (useLot) {
          newOrder.lots = this.mapLots(this.lot.selected)
        } else if (useSerial) {
          newOrder.serials = this.mapSerials(this.serial.selected)
        }

        that.addPosOrder(newOrder)

        this.$nextTick(() => {
          /**
         * add order to firbase
         */
          if (isActive_menuOnline && isMenuOnlineQueue) {
            const payload = {
              ...transformOrderRef(newOrder),
              order_id: order_id,
              product_id: product.product_id,
              status: 'approved',
              created_at: new Date().getTime(),
            }
            this.createOrder({
              queueNumber: `${queue_number}`,
              orderId: order_id,
              payload: payload,
            })
          }
        })
      } else {
        const oldOrder = {
          order_id: that.order.order_id,
          uuid: that.order.uuid,
          queue_number: queue_number,
          table_number: table_number,
          sku_id: sku_id,
          item: item,
          price: sku.price,
          cost: sku.cost,
          quantity: quantity,
          attributes: sku.attributes,
          modifiers: modifiers,
          discounts: discounts,
          taxes: taxes,
          note: note,
          stock_id: stock_id,
          warehouse_id: warehouse_id,
        }
        if (useLot) {
          oldOrder.lots = this.mapLots(this.lot.selected)
        } else if (useSerial) {
          oldOrder.serials = this.mapSerials(this.serial.selected)
        }
        that.updatePosOrder(oldOrder)
        // call setPosLocalStorage
        this.setPosLocalStorage({ psId: this.posSession.ps_id })

        /**
         * update order to firbase
         */
        this.$nextTick(() => {
          const orders = this.getPosOrdersById({
            queue_number: this.queue_number,
            table_number: this.table_number,
            isDeleteQueue: false,
          })
          for (const order of orders) {
            if (isActive_menuOnline && isMenuOnlineOrder(order) && order_id === order.order_id) {
              this.updateOrder({
                queueNumber: `${order.queue_number}`,
                orderId: order.order_id,
                payload: transformOrderRef(order),
              })
            }
          }
        })
      }

      // go to choose product page
      this.setPosSection(this.backTo)
    },
    handleKeyup (e) {
      let lastSecIsBarcode = this.$store.state.pos.pos.lastSecIsBarcode
      if (e.key == 'Enter' && !lastSecIsBarcode) {
        this.onClickDone()
      }
      if (e.key == 'Escape') {
        this.setPosSection(this.backTo)
      }
    },
    isNotAvailable (price) {
      if (price.is_available == false) {
        return true
      }
      return false
    },
    isOutOfStock (price) {
      const enableSaleDisable = this.posSettings.product_out_of_stock.sale_disabled === true
      const hasStocks = price.stocks.length > 0
      const branchAssignWhId = this.$store.state.posBranch.branch.whId
      const isAssignedSkuToStock = this.isAssignedSkuToStock(branchAssignWhId, price.sku_id)
      if (enableSaleDisable && hasStocks && isAssignedSkuToStock) {
        const currentStock = price.total_instock
        const configStockCount = this.posSettings.product_out_of_stock.count
        if (currentStock <= configStockCount) {
          return true
        }
      }
      return false
    },
    selectedInputQuantity () {
      setTimeout(() => {
        try {
          this.$refs['quantity']
            .$el.querySelector('.vs-input-number--input')
            .select()
        } catch (e) {}
      }, 100)
    },
    async handleSkuIdChange (e) {
      const sku_id = this.radioSkuId
      const sku = this.getSku(sku_id)
      const branchAssignWhId = this.$store.state.posBranch.branch.whId
      const customPrice = this.isCustomPrice(sku_id)
      const useLot = this.isProductUseLot(sku)
      const useSerial = this.isProductUseSerial(sku)

      if (useLot) {
        this.lot.selected = []
        this.lot.sort.key = 'date_in'
        this.lot.sort.value = 'asc'
        this.lot.product = this.product
        this.lot.skuId = sku_id
        this.lot.whId = branchAssignWhId
        this.lot.isCustomPrice = customPrice
        await this.fetchLotData()
        this.lotModal.show = true
      } else if (useSerial) {
        this.serial.selected = []
        this.serial.sort.key = 'date_in'
        this.serial.sort.value = 'asc'
        this.serial.product = this.product
        this.serial.skuId = sku_id
        this.serial.whId = branchAssignWhId
        this.serial.isCustomPrice = customPrice
        await this.fetchSerialData()
        this.serialModal.show = true
      } else if (customPrice) {
        this.setPosSectionWith({
          section: 'custom-price',
          data: {
            product: this.product,
            sku_id: this.radioSkuId,
          },
        })
      }

      this.isInvalid = false
    },
    isCustomPrice (skuId) {
      const sku = this.getSku(skuId)
      return sku.price === null
    },
    isProductUseLot (sku) {
      return sku.config.inventory.use_lot
    },
    isProductUseSerial (sku) {
      return sku.config.inventory.use_serial
    },
    recheckRadioSkuId (selectedItems) {
      if (selectedItems.length === 0) {
        this.radioSkuId = null
        this.quantity = 1
      }
    },
    async handleSumitLotModal ({ lots }) {
      this.lotModal.show = false
      this.lot.selected = lots

      if (this.lot.isCustomPrice) {
        const mapLots = this.mapLots(this.lot.selected)
        this.$nextTick(() => {
          this.setPosSectionWith({
            section: 'custom-price',
            data: {
              product: this.product,
              sku_id: this.radioSkuId,
              lots: mapLots,
            },
          })
        })
      }

      this.quantity = this.lot.selected.reduce((total, { unit }) => total + Number(unit), 0)
      this.recheckRadioSkuId(this.lot.selected)
    },
    handleCancleLotModal () {
      this.lotModal.show = false
      this.recheckRadioSkuId(this.lot.selected)
    },
    handleCloseLotModal () {
      this.lotModal.show = false
      this.recheckRadioSkuId(this.lot.selected)
    },
    async onClickOpenLotModal () {
      if (!this.radioSkuId && this.product.prices.length === 1) {
        this.radioSkuId = this.product.prices[0].sku_id
      }

      const branchAssignWhId = this.$store.state.posBranch.branch.whId
      this.lot.sort.key = 'date_in'
      this.lot.sort.value = 'asc'
      this.lot.product = this.product
      this.lot.skuId = this.radioSkuId
      this.lot.whId = branchAssignWhId
      this.lot.isCustomPrice = false
      await this.fetchLotData()
      this.lotModal.show = true
    },
    async handleSumitSerialModal ({ serials }) {
      this.serialModal.show = false
      this.serial.selected = serials

      if (this.serial.isCustomPrice) {
        const mapSerials = this.mapSerials(this.serial.selected)
        this.$nextTick(() => {
          this.setPosSectionWith({
            section: 'custom-price',
            data: {
              product: this.product,
              sku_id: this.radioSkuId,
              serials: mapSerials,
            },
          })
        })
      }

      this.quantity = this.serial.selected.reduce((total, { unit }) => total + Number(unit), 0)
      this.recheckRadioSkuId(this.serial.selected)
    },
    handleCancleSerialModal () {
      this.serialModal.show = false
      this.recheckRadioSkuId(this.serial.selected)
    },
    handleCloseSerialModal () {
      this.serialModal.show = false
      this.recheckRadioSkuId(this.serial.selected)
    },
    async onClickOpenSerialModal () {
      if (!this.radioSkuId && this.product.prices.length === 1) {
        this.radioSkuId = this.product.prices[0].sku_id
      }

      const branchAssignWhId = this.$store.state.posBranch.branch.whId
      this.serial.sort.key = 'date_in'
      this.serial.sort.value = 'asc'
      this.serial.product = this.product
      this.serial.skuId = this.radioSkuId
      this.serial.whId = branchAssignWhId
      this.serial.isCustomPrice = false
      await this.fetchSerialData()
      this.serialModal.show = true
    },
    stockCount (product, skuId) {
      const hasMoreThenOneSkus = product.prices.length > 1
      const hasStocks = product.prices[0].stocks.length > 0
      const branchAssignWhId = this.$store.state.posBranch.branch.whId
      const isAssignedSkuToStock = this.isAssignedSkuToStock(branchAssignWhId, product.prices[0].sku_id)
      if (hasMoreThenOneSkus && hasStocks && isAssignedSkuToStock) {
        const sku = product.prices.find((price) => price.sku_id === skuId)
        return sku && sku.total_instock
      }
      return null
    },
  },

  watch: {
    quantity (qty) {
      this.switchDiscountIds = this.getSwitchDiscountIds(this.product.discounts, { updateGeneral: false, updateCondition: true })
    },
    checkBoxModifierOptionIds() {
      const isInvalidModifiers = this.mapProductModifiers.some((item) => item.isInvalid)
      if (isInvalidModifiers && this.isInvalidModifierCount > 0) {
        this.isValidModifiers
      }
    },
  },

  mounted () {
    const that = this

    /**
     *  edit
     */
    if (this.isEdit) {
      let order = this.order
      this.radioSkuId = order.sku_id

      // fix bugs
      this.$nextTick(() => {
        this.quantity = order.quantity
      })

      this.checkBoxModifierOptionIds = this.getCheckBoxModifierOptionIds(order.modifiers)
      this.switchDiscountIds = this.getSwitchDiscountIds(order.discounts, { updateGeneral: true, updateCondition: true })
      this.switchTaxIds = this.getSwitchTaxIds(this.order.taxes)
      this.note = order.note
    } else {
      // check assign tax
      if (this.product.taxes) {
        // auto active tax
        this.switchTaxIds = this.getSwitchTaxIds(this.product.taxes)
      } else {
        // set switch taxes data
        for (let i in this.taxes) {
          this.switchTaxIds.push(false)
        }
      }
      // check assign discount
      if (this.product.discounts) {
        // auto active discount
        this.switchDiscountIds = this.getSwitchDiscountIds(this.product.discounts, { updateGeneral: true, updateCondition: true })
      } else {
        // set switch discounts data
        for (let i in this.discounts) {
          this.switchDiscountIds.push(false)
        }
      }
      // set default attr
      if (this.sku_id) {
        this.radioSkuId = this.sku_id
      } else {
        // if prices is 1 than auto selected
        if (this.product.prices.length == 1) {
          this.radioSkuId = this.product.prices[0].sku_id
        }
      }
    }

    // set default lot and serial. case:
    // 1. when back from custom price page
    // 2. when click edit on choose product page
    if (this.sku_id || this.isEdit) {
      let selectedLots
      let selectedSerials

      // get lots from orders for edit
      if (this.isEdit) {
        selectedLots = this.order.lots
        selectedSerials = this.order.serials
      } else {
        // get lots from mixin for custom price
        selectedLots = this.selectedLots
        selectedSerials = this.selectedSerials
      }

      if (selectedLots && selectedLots.length) {
        this.lot.selected = selectedLots.map((lot) => {
          return {
            skuId: this.sku_id,
            lotId: lot.lotId,
            lotCode: lot.lotCode,
            binId: lot.binId,
            binName: lot.binName,
            unit: lot.unit,
          }
        })
      }

      if (selectedSerials && selectedSerials.length) {
        this.serial.selected = selectedSerials.map((serial) => {
          return {
            skuId: this.sku_id,
            serId: serial.serId,
            serCode: serial.serCode,
            serialNumber: serial.serialNumber,
            binId: serial.binId,
            binName: serial.binName,
            unit: 1,
          }
        })
      }
    }

    /**
     * auto select quantity
     */
    const isDesktop = this.$store.getters['getDevice'] == 'desktop'
    if (isDesktop && (!this.isSelectedLot && !this.isSelectedSerial)) {
      this.selectedInputQuantity()
    }
    /**
     *  auto done if using barcode scanner
     */
    if (this.useBarcodeScanner) {
      let noCustomprice = this.getSku(this.sku_id).price != null
      if (noCustomprice) {
        this.onClickDone()
      }
    }

    // event keyboard
    window.addEventListener('keyup', this.handleKeyup, false)
  },
  destroyed: function () {
    // remove event keyboard
    window.removeEventListener('keyup', this.handleKeyup, false)
  },
}



// WEBPACK FOOTER //
// ./src/mixins/pos/chooseAttribute.js